"use strict";

import * as dom from "./lib/dom";

function copyLink() {
    const linkBtn = document.querySelector(".js-copy-link");
    if (!linkBtn) {
        return;
    }

    linkBtn.addEventListener("click", (e) => {
        e.preventDefault();
        //const btnText = linkBtn.querySelector("span");
        let dummy = document.createElement("input");
        const text = window.location.href;

        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);
        //btnText.innerHTML = "Copiado";
        alert("Copiado");
    });
}

export default function () {
    window.addEventListener("DOMContentLoaded", function () {
        copyLink();
    });
}
